import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

/**
 * IMPORTANT: This method is a temporal utility to help in the migration from
 * React v16 to v18. It should be removed after the migration is completed.
 *
 * Render a component using the correct react-dom APIs dependending
 * on the ReactDOM version available in the context of execution.
 *
 * @param {Object} component React node to be rendered.
 * @param {Object} DOMEl DOM Element
 * @return {Object} ReactDOM rendered component
 */
export const renderUsingContextVersion = (component, DOMEl) => {
  const isReactDomV18 = typeof createRoot === 'function';

  return isReactDomV18
    ? createRoot(DOMEl).render(component)
    // eslint-disable-next-line react/no-deprecated
    : ReactDOM.render(component, DOMEl);
};
